import Image from 'next/image'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { chooseCorrectColors } from './utils/chooseCorrectColors'

type Props = { readonly content: any }

const ArticleHeaderImg: React.FC<Props> = ({ content }) => {
  const { t } = getTranslate()
  const imgFromStrapi = content.cover?.data?.attributes?.url
  const isSvg = imgFromStrapi?.includes('.svg')
  const imageLayout = content.coverLayout ?? 'center'

  const imgSrc = imgFromStrapi && isSvg ? chooseCorrectColors(imgFromStrapi) : imgFromStrapi
  const imgAlt = content.cover.alt ?? content.title ?? t('general.illustrationImage')

  return (
    <>
      <div className="h-[300px] w-full overflow-hidden rounded-[20px] bg-blue-500">
        <div className="relative flex h-full">
          {imgSrc &&
            (isSvg ? (
              <img src={imgSrc} loading="eager" alt={imgAlt} className="mx-auto p-6" />
            ) : (
              <Image
                alt={imgAlt}
                src={imgSrc}
                className={cn('object-contain p-6', imageLayout === 'fill' && 'object-cover p-0')}
                fill
                sizes="274px"
                loading="eager"
                priority
              />
            ))}
        </div>
      </div>
    </>
  )
}

export default ArticleHeaderImg
